import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Spinner from "../../images/meets/Spinner.gif"
import { Row, Col, Card, InputGroup, FormControl, Image } from "react-bootstrap"
import { Link } from "gatsby"
import Parser from "html-react-parser"
import { saveLead, checkEmail } from "../../utils/emails"
import { PayPalButton } from "react-paypal-button-v2"
import techoImgOne from "../../images/techo/01.jpg"
import cleverItLogo from "../../images/techo/logo-cleverit.png"
import imageMaker from "../../images/techo/imagarket.png"

export let Organizadores = props => {
  return (
    <>
      <section>
        <RowOrg className=" row justify-content-center align-items-center">
          <Col xl={4} lg={4} md={6} sm={8} style={{ paddingBottom: "2rem" }}>
            <RowText>
              <h1>Organizador</h1>
            </RowText>
            <Row className=" justify-content-center align-items-center">
              <Image src={cleverItLogo} fluid></Image>
            </Row>
          </Col>
          <Col xl={4} lg={4} md={6} sm={8}>
            <RowText>
              <h1>Premios cortesía de</h1>
            </RowText>
            <Row className=" justify-content-center align-items-center">
              <Image src={imageMaker} fluid></Image>
            </Row>
          </Col>
        </RowOrg>
      </section>
    </>
  )
}

const RowOrg = styled.div`
  justify-content: center;
  margin-top: 3rem;
  text-align: center;
  padding-right: 20px;
  padding-left: 20px;
`
const BtnSend = styled.button`
  background-color: #efefef !important;
  padding: 1rem 2rem 1rem 2rem;
  border-radius: 6px;
  border-width: 0;
  :active {
    background-color: #efefef !important;
  }
  :hover {
    background-color: #efefef !important;
  }
  :visited {
    background-color: #efefef !important;
  }
  :link {
    background-color: #efefef !important;
  }
`
const InputAmount = styled.input`
  padding: 1rem 2rem 1rem 1rem;
  margin-right: 2rem;
  border-radius: 6px;
  border-width: 0;
  @media (max-width: 502px) {
    margin-right: 0;
    margin-bottom: 2rem;
    padding: 1rem 5rem 1rem 1rem;
  }
  @media (max-width: 339px) {
    padding: 1rem 3rem 1rem 1rem;
  }
`
const RowText = styled.div`
  margin-right: auto;
  margin-left: auto;
  justify-content: center !important;
  width: 100%;
  h4 {
    text-align: center !important;
  }
  h1 {
    text-align: center !important;
    font-size: 2rem;
  }
  h2 {
    text-align: center !important;
    font-family: "Poppins", sans-serif;
    font-size: 1.5rem !important;
  }
  a {
    color: white;
    font-family: "Poppins", sans-serif;
    font-size: 1.5rem !important;
    font-weight: bold;
  }
  li {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
    font-size: 1.5rem;
  }
  ol {
    margin-top: 0.5rem !important;
    font-size: 1.5rem;
  }
`

const Title = styled.h2`
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  line-height: 1.2;
  padding-top: 2rem;
  padding-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
  margin-top: 4rem;
  @media (max-width: 600px) {
    font-size: 2rem;
    padding-bottom: 2rem;
  }
  @media (max-width: 400px) {
    font-size: 1.3rem;
    margin-top: 2rem;
    padding-bottom: 1rem;
  }
`

export default Organizadores
